import { AppState } from '@app-state/index';
import { ToastInputSettings } from '@custom-types/core/app-toast-notifications.model';
import { createSelector } from '@ngrx/store';

const selectToastNotifications = (state: AppState): ToastInputSettings => state?.appToastNotifications;

export const appToastNotificationsSelector = createSelector(selectToastNotifications, (toastSettings) => {
  /**
   * HMR workaround: During Hot Module Replacement, the state can sometimes
   * get into an inconsistent state where the toast settings are undefined.
   * To prevent runtime errors in such cases, we return null if toastSettings
   * is undefined during HMR.
   */
  if (!toastSettings && module.hot) {
    return null;
  }
  return toastSettings;
});
